import { z } from 'zod'

export const columns = [
  {
    id: 'entityPan',
    label: 'Entity pan',
    width: '150px',
  },
  {
    id: 'entityName',
    label: 'Entity name',
    width: '200px',
  },
  {
    id: 'createdBy',
    label: 'Created by',
    width: '150px',
  },
  {
    id: 'createdDate',
    label: 'Created date',
    width: '150px',
  },
  {
    id: 'lastModifiedBy',
    label: 'Updated by',
    width: '150px',
  },
  {
    id: 'lastModifiedDate',
    label: 'Updated date',
    width: '150px',
  },
]

// Validation for yyyymmdd date format
const ddMMyyyyListZod = z
  .string()
  .regex(
    /^((0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4}(\s*,\s*(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/\d{4})*)?$/,
    'Invalid Input. Example: 29/08/2025, 01/09/2025'
  )
// Search fields constant (add Load ID and all columns)
export const searchFields = [
  ...columns.map(col => {
    if (col.id === 'createdDate' || col.id === 'lastModifiedDate') {
      return {
        id: col.id,
        label: col.label,
        type: 'text',
        placeholder: `Example: 25/08/2025 (dd/mm/yyyy)`,
        zod: ddMMyyyyListZod,
      }
    }
    return {
      id: col.id,
      label: col.label,
      type: col.type || 'text',
      placeholder: `Enter ${col.label}`,
    }
  }),
]
